export interface QueuedEvent {
  name: string
  properties: Record<string, unknown>
  timestamp: Date
}

export class EventQueue {
  private readonly events: QueuedEvent[] = []
  private dropped = 0

  constructor(private readonly limit: number) {}

  push(event: QueuedEvent): void {
    this.events.push(event)
    while (this.events.length > this.limit) {
      this.events.shift()
      this.dropped++
    }
  }

  drain(): QueuedEvent[] {
    return this.events.splice(0, this.events.length)
  }

  get size(): number {
    return this.events.length
  }

  get droppedCount(): number {
    return this.dropped
  }
}
